/* tslint:disable */
/* eslint-disable */
export enum WorkBudgetAccountTypeEnum {
  Umsatz = 'umsatz',
  Deckungsbeitrag1 = 'deckungsbeitrag1',
  Lohnkosten = 'lohnkosten',
  Custom = 'custom',
  StundenKorrekturErtrag = 'stunden_korrektur_ertrag',
  StundenKorrekturAufwand = 'stunden_korrektur_aufwand'
}
